import { blue, green, orange, red, yellow } from '@ant-design/colors';
import { DeleteOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { Card, Spin, Typography } from 'antd';
import React from 'react';
import { DemoStatus, VideoCardProps } from '../../libs/types/src';
import { VideoThumbnailGenerator } from '../../libs/ui/src/components';
import Badge from './Badge';

const { Title, Text } = Typography;

const VideoCard: React.FC<VideoCardProps> = ({
    id,
    title,
    date,
    time,
    status,
    description,
    attachment,
    onClick,
    onRemove,
    removeDemoLoading,
    removeDemoError,
    updateCurrentStatus,
}) => {

    const statusMap = {
        [DemoStatus.NOTIFICATION_RECEIVED]: 'Notification Received',
        [DemoStatus.PROCESSING]: 'Processing',
        [DemoStatus.PROCESSED]: 'Processed',
        [DemoStatus.FAILED]: 'Failed',
        [DemoStatus.INITIALIZED]: 'Initialized',
        [DemoStatus.REINDEXING]: 'Reindexing',
    };

    const statusColorMap = {
        [DemoStatus.NOTIFICATION_RECEIVED]: blue,
        [DemoStatus.PROCESSING]: orange,
        [DemoStatus.PROCESSED]: green,
        [DemoStatus.FAILED]: red,
        [DemoStatus.INITIALIZED]: blue,
        [DemoStatus.REINDEXING]: yellow,
    };

    return (
        <Card hoverable className="demos-video-card" onClick={onClick} style={{ position: 'relative' }}>
            {removeDemoLoading ? (
                <span className="demos-video-remove-icon">
                    <Spin size="small" />
                </span>
            ) : (
                onRemove && (
                    <span
                        className="demos-video-remove-icon"
                        onClick={e => {
                            e.stopPropagation();
                            onRemove();
                        }}
                    >
                        <DeleteOutlined />
                    </span>
                )
            )}
            <div className="demos-video-thumb">
                <VideoThumbnailGenerator videoUrl={attachment} />
            </div>
            <div className="demos-video-content">
                <Title level={5} className="demos-video-title">{title}</Title>
                <Text type="secondary" className="demos-video-date">
                    {date} &nbsp; <VideoCameraOutlined /> {time}
                </Text>
                <div className="demos-video-status">
                    {status !== null && status !== undefined && statusMap[status] && statusColorMap[status] && (
                        <Badge
                            label={statusMap[status]}
                            bg={statusColorMap[status][1]}
                            color={statusColorMap[status][5]}
                        />
                    )}
                </div>
                <Text className="demos-video-description">{description}</Text>
            </div>
        </Card>
    );
};

export default VideoCard; 